export default __webpack_public_path__ + "static/media/flowers_wide_lowRes.977bee70.jpg";